import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import useStyles from './styles';

export default function CheckboxesGroup(props) {
  const classes = useStyles();
  const {
    reportFilters,
    handleChangeCheckbox,
    section,
    maxHeight = '600px',
    xs = 3,
    handleClearAll,
    value,
    stage
  } = props;

  const onPressSelectAll = () => {
    handleClearAll(true, value);
  };

  const onPressClearAll = () => {
    handleClearAll(false, value);
  };

  return (
    <div className={classes.root}>
      <Grid container style={{ minWidth: 700 }}>
        <FormControl component="fieldset" className={classes.formControl}>
          <FormGroup style={{ maxHeight, display: 'block' }}>
            {section === undefined && (
              <div>
                <Link
                  className={classes.linkSelectAllSmall}
                  component="button"
                  variant="body2"
                  onClick={onPressSelectAll}
                >
                  Select All
                </Link>
                <> - </>
                <Link
                  className={classes.linkClearAllSmall}
                  component="button"
                  variant="body2"
                  onClick={onPressClearAll}
                >
                  Clear
                </Link>
              </div>
            )}
            {reportFilters.map(filter => (
              <Grid
                item
                xs={xs}
                key={filter.id}
                className={classes.checkboxArea}
              >
                <FormControlLabel
                  label={filter.filterName}
                  control={
                    <Checkbox
                      checked={filter.checked}
                      onChange={handleChangeCheckbox(
                        filter.id,
                        filter.tabId,
                        section,
                        stage
                      )}
                      value={filter.id}
                      disabled={filter.disabled}
                    />
                  }
                />
              </Grid>
            ))}
          </FormGroup>
        </FormControl>
      </Grid>
    </div>
  );
}
